import { Component } from '@angular/core';
import { ClientsModule } from '../../../../clients/clients.module';
import { LayoutModule } from '../../../layout/layout.module';

@Component({
  selector: 'app-client-editor-dashboard-page',
  standalone: true,
  imports: [
    LayoutModule,
    ClientsModule,
  ],
  templateUrl: './client-editor-dashboard-page.component.html',
  styleUrl: './client-editor-dashboard-page.component.sass',
})
export class ClientEditorDashboardPageComponent {

}
